<template>
  <div id="page-todos">
    <Confirm
      ref="confirmModal"
      type="danger"
      :message="$t('COMMON.ARE_YOU_SURE')"
      @confirm="delete_todo_clicked(selectedTodoId)"
    />

    <TodoActiveEditorModal 
      ref="active-editor-modal"
      :todo_id="selected_todo_id"
    />

    <m-row>
      <m-col lg="10">
        <memlist-text-input
          id="search_second"
          name="search_second"
          layout="vertical"
          placeholder="Sök ärende"
          style="min-width: 380px;"
          v-model="search"
        />

      </m-col>
      <m-col lg="2">
        <memlist-spinner v-if="searching"></memlist-spinner>
      </m-col>
    </m-row>
    

    <m-row>
      <m-col cols="6" style="align-content: end;">
        <div class="bottom-alignment">
          <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
        </div>

      </m-col>
      <m-col cols="6">
        
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">
          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
          />

        </div>

      </m-col>
    </m-row>

    <memlist-static-table
      id="todo-table"
      style="width: 100%;"
      class="table-striped"
      :fields="todo_headers"
      :items="live_todos"
      :filter="search"
      :per-page="per_page"
      :current-page="current_page"
      head-variant="light"
      ref="todo-table"
    >
  
      <template #cell(status)="row">
        <memlist-badge
          v-if="row.item.status === 'NOT'"
          status="danger"
          style="max-width:150px;"
        >
        {{ $t('TODO.STATUSES.NOT') }}
        </memlist-badge>

        <memlist-badge
          v-if="row.item.status === 'DONE'"
          status="primary"
          style="max-width:150px;"
        >
        {{ $t('TODO.STATUSES.DONE') }}
        </memlist-badge>

        <memlist-badge
          v-if="row.item.status === 'WAIT'"
          status="warning"
          style="max-width:150px;"
        >
        {{ $t('TODO.STATUSES.WAIT') }}
        </memlist-badge>

        <memlist-badge
          v-if="row.item.status === 'CN'"
          status="success"
          style="max-width:150px;"
        >
        {{ $t('TODO.STATUSES.CN') }}
        </memlist-badge>

      </template>

      <template #cell(actions)="data">

        <memlist-table-button :notification="data.item.num_notifications" class="mr-2" @click="edit_todo_clicked(data.item.todo_id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
        
      </template>
      
      
    </memlist-static-table>

    <LiveTaskEdit
      v-if="liveTodoTask"
      ref="editLiveTask"
      :task="liveTodoTask"
      @task_updated="task_updated"
      @close_edit_live_task="close_edit_live_task"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import TodoTable from '@/view/pages/ml/todo/TodoTable.vue';
import TodoEditModal from '@/view/pages/ml/todo/TodoEditModal.vue';
import TodoActiveEditorModal from '@/view/pages/ml/todo/TodoActiveEditorModal.vue';
import LiveTaskEdit from '@/view/pages/ml/todo/LiveTaskEdit.vue';
import FilesListModal from '@/view/pages/ml/todo/FilesListModal.vue';
import ChatBox from '@/view/components/chatBox.vue';


export default {
  name: 'TodoActiveItemsTab',
  mixins: [ toasts ],
  components: {
    ChatBox,
    FilesListModal,
    LiveTaskEdit,
    
    TodoTable,
    TodoEditModal,
    TodoActiveEditorModal
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId'])
  },
  mounted() {
    this.load_data();
  },
  data() {
    return {
      searching: false,
      selected_todo_id: null,
      selected_todo: {},
      liveTodoTask: null,
      activeExpanded: [],
      closedExpanded: [],
      singleExpand: false,
      headerProps: {
        sortByText: 'Sortera'
      },
      todo_headers: [
        { 
          label: 'Ärendenamn', 
          key: 'name', 
          tdClass: 'td-short4',
          thClass: 'td-short4',
          
          sortable: true,
        },
        {
          key: 'company.name',
          label: 'Förening',
          sortable: true,
          tdClass: 'td-overflow',
          thClass: 'td-overflow',
          
        },
        { 
          label: '# F', 
          key: 'num_files',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          sortable: true,
        },
        {
          label: '# M',
          key: 'num_comments',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          sortable: true,
        },
        { 
          label: 'Uppdaterat', 
          key: 'updated_at',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          
          sortable: true,
        },
        { 
          label: 'Status', 
          key: 'status',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          sortable: true,
        },
        { 
          label: '', 
          key: 'actions', 
          thClass: 'td-short4', 
          tdClass: 'td-short4' 
        },
        
      ],
      selectedTodoId: null,
      selected_tasks: [],
      selected_task: null,
      todos: [],
      live_todos: [],
      current_page: 1,
      per_page: 100,
      total_rows: 0,
      comments: [],
      comment: '',
      todo_id: null,
      todo_task_id: null,
      columns: ['name', 'code', 'uri'],
      search: '',
      cls_search: '',
      tab: null,
      
      todoStatusPrio: {
        REJ: -4,
        CLOSE: -3,
        INVALID: -2,
        WAIT: -1,
        DRAFT: 0,
        NOT: 1,
        DONE: 2,
        CN: 3,
        DEL: 4,
        ACC: 5,
        BAC: 7,
        FUT: 8
      },
      rowsPerPage: [10, 20, 40, -1]
    };
  },
  watch: {

    search() {
      this.load_data();
    },

    currentCompanyId(newValue, oldvalue) {
      if (newValue) {
        this.load_data();
      }
    },
    currentPeriodId(newValue, oldValue) {
      if (newValue) {
        this.load_data();
      }
    }
  },
  methods: {

    draft_todo_updated(todo) {
      const index = this.draft_todos.findIndex(item => item.todo_id === todo.todo_id);

      if (index > -1) {
        this.draft_todos[index] = todo;
        // Vue3 compatability for Vue.set
        this.draft_todos = [...this.draft_todos];
      }
    },


    history_todo_updated(todo) {
      const index = this.history_todos.findIndex(item => item.todo_id === todo.todo_id);

      if (index > -1) {
        this.history_todos[index] = todo;
        // Vue3 compatability for Vue.set
        this.history_todos = [...this.history_todos];
      }
    },

    live_todo_updated(todo) {
      const index = this.live_todos.findIndex(item => item.todo_id === todo.todo_id);

      if (index > -1) {
        this.live_todos[index] = todo;
        // Vue3 compatability for Vue.set
        this.live_todos = [...this.live_todos];
      }
    },

    async delete_file_clicked(file_id, todo_task_id) {
      try {
        const res = await axios.delete(`/todo_task/${todo_task_id}/file/${file_id}`);

        if (res.status === 204) {
          this.selected_task.files = this.selected_task.files.filter(item => item.file_id !== file_id);

          this.selected_task = { ...this.selected_task };

          const index = this.live_todos.findIndex(item => item.todo_id === this.selected_task.todo_id);

          // if found
          if (index > -1) {
            this.live_todos[index].num_files = this.live_todos[index].num_files - 1;
            // Vue3 compatability for Vue.set
            this.live_todos = [...this.live_todos];
          }


          this.toastr('success', this.$t('COMMON.OK'), 'Filen togs bort');

          return;
        }
      }
      catch (err) {
        console.error(err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte radera fil');

    },


    closeManageModalClicked() {
      this.$refs['manageLiveTodo'].hide();
    },


    closeTodoClicked() {
      this.closeManageModalClicked();
      axios
        .post('/todo/close', { todo_id: this.selectedTodoId })
        .then(res => {
          const todo = this.getTodoWithId(this.selectedTodoId);
          if (res.status === 200 && todo !== null) {
            todo.status = 'CLOSE';
            this.history_todos.push(todo);
            this.todos = this.todos.filter(item => item.todo_id !== this.selectedTodoId);
            this.draft_todos = this.draft_todos.filter(item => item.todo_id !== this.selectedTodoId);
            this.live_todos = this.live_todos.filter(item => item.todo_id !== this.selectedTodoId);
          } else this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte stänga ärendet');
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte stänga ärendet');
        });
    },


    getTodoWithId(todo_id) {
      for (var i = 0; i < this.todos.length; ++i) {
        if (this.todos[i].todo_id === todo_id) {
          return this.todos[i];
        }
      }

      return null;
    },

    edit_todo_clicked(todo_id) {
      this.selected_todo_id = todo_id;
      this.$refs['active-editor-modal'].show();
    },
    
    async send_comment_clicked() {
      try {
        const res = await axios.post(`/todo_task/comment/${this.todo_task_id}`, {
          from: 'top',
          is_top: true,
          comment: this.comment,
          todo_task_id: this.todo_task_id
        });

        if (res.status === 201) {
          this.comment = '';
          this.comments.push(res.data);
          this.load_data();
        }
        
      }
      catch (err) {
        console.error('send_comment_clicked', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte skicka kommentar');
      }
      
    },


    show_comments_clicked(todo_task_id) {

      this.todo_task_id = todo_task_id;

      axios
        .get(`/todo_task/${todo_task_id}`)
        .then(res => {
          this.comments = res.data.comments;

          this.$refs['chatBoxModal'].show();
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta kommentarer');
        });
    },

    task_updated(todo_task_id) {
      this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.SUBTASK_UPDATED'));
    },

    close_edit_live_task() {
      this.liveTodoTask = null;
    },


    select_row_clicked(todo_task_id) {

      // this solution is shit
      var that = this;

      for (const todo of this.live_todos) {
        for (const task of todo.tasks) {
          if (task.todo_task_id === todo_task_id) {
            this.liveTodoTask = task;

            setTimeout(function() {
              that.$refs['editLiveTask'].init();
            }, 100);

            return;
          }
        }
      }
    },


    delete_task_child_clicked(todo_task_id) {
      axios
        .delete(`/todo_task/${todo_task_id}`)
        .then(res => {
          if (res.status === 204) {
            this.live_todos.filter((todo, i) => {
              todo.tasks.filter((task, t) => {
                if (task.todo_task_id === todo_task_id) {
                  this.live_todos[i].tasks.splice(t, 1);
                }
              });
            });

            this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.SUBTASK_DELETED'));
          }
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_DELETE_SUBTASK'));
        });

    },
    update_task_status() {
      this.load_data();
    },
    todo_updated(todo) {
      this.load_data();
    },
    todo_published(todo) {
      this.load_data();
    },

    async load_data() {
      this.searching = true;
      
      try {

        const res = await axios.get(`/todo?type=PA&creator_company_id=${this.currentCompanyId}&search=${this.search}`)

        if (res.status === 200) {

          this.todos = res.data;

          this.live_todos = [];
          this.draft_todos = [];
          this.history_todos = [];

          for (var i = 0; i < this.todos.length; ++i) {
            var t = this.todos[i];

            if (t.status === 'INVALID' || t.status === 'DRAFT') {
              this.draft_todos.push(t);
            } else if (t.status === 'DEL' || t.status === 'CLOSE') {
              this.history_todos.push(t);
            } else {
              //else if (t.status === 'NOT' || t.status === 'WAIT' || t.status === 'DONE' || t.status === 'CN' || t.status === 'ACC' || t.status === 'REJ') {
              this.live_todos.push(t);
            }
          }
          this.live_todos.map(function(item) {
            if (item.company_name == '') item.company_name = this.$t('COMMON.ALL');
          });

          this.searching = false;
          this.total_rows = this.live_todos.length;

          return;
        }
      }
      catch (err) {
        console.error(err);

      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_GET'));

      this.searching = false;

    },


    create_todo_clicked() {
      const tab_ref = this.selectedTab();
      this.$refs[`${tab_ref}`].show();
      this.selected_todo = {}
      this.$refs[`${tab_ref}`].createTodo();
    },


    select_todo_clicked(todo_id) {
      const tab_ref = this.selectedTab();

      const todo = this.todos.find(item => item.todo_id === todo_id);

      this.selected_todo = { ...todo };

      this.$refs[`${tab_ref}`].show();
    },

    /// when the todo has been published from the Editor
    published(todo) {
      const draft_item_index = this.draft_todos.findIndex(item => item.todo_id === todo.todo_id);
      const item_index = this.todos.findIndex(item => item.todo_id === todo.todo_id);

      if (draft_item_index >= 0) {
        this.draft_todos.splice(0, draft_item_index);
      }

      if (item_index >= 0) {
        this.todos.splice(0, item_index);
      }
    },

    async delete_todo_clicked(todo_id) {

      try {
        this.closeManageModalClicked();
        const res = await axios.delete(`/todo/${todo_id}`)

        if (res.status === 204) {
          this.todos = this.todos.filter(item => item.todo_id !== todo_id);
          this.draft_todos = this.draft_todos.filter(item => item.todo_id !== todo_id);
          this.live_todos = this.live_todos.filter(item => item.todo_id !== todo_id);
          this.history_todos = this.history_todos.filter(item => item.todo_id !== todo_id);
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.DELETED'));

          return;
        }
      }
      catch (err) {
        console.error('delete_todo_clicked error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_DELETE'));
    },

    confirm_delete() {
      this.$refs['confirmModal'].show();
    },

    selectedTab() {
      let tab = '';
      if (this.tab === 0) tab = 'todoEdit-draft';
      if (this.tab === 1) tab = 'todoEdit-active';
      if (this.tab === 2) tab = 'todoEdit-finished';
      return tab;
    },

  }
};
</script>

